import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import { SelectInputProps } from "./types";
import { classNames } from "utils/classNames";
import { SearchIcon } from "@heroicons/react/outline";

const styles = {
  control: (css: any) => ({
    ...css,
    borderColor: "none",
    borderWidth: "none",
    borderRadius: "none",
  }),
  option: (css: any) => ({
    ...css,
    backgroundColor: "none",
    textColor: "none",
  }),
  input: (css: any) => ({
    ...css,
    input: {
      outline: "none",
    },
    "*:focus": {
      boxShadow: "none",
    },
  }),
  menuPortal: (base: any) => ({
    ...base,
    zIndex: 9999,
  }),
};

const SearchSelectInput: React.FunctionComponent<SelectInputProps> = (
  props
) => {
  const { options, label } = props;
  const { t } = useTranslation();

  return (
    <div
      className="col-span-6 sm:col-span-3"
      data-test="country-select-wrapper"
    >
      <div className="flex justify-between">
        <label
          htmlFor={props.id}
          className="block text-sm font-medium text-gray-700"
        >
          {label}
        </label>
        {!props.required && (
          <span id="phone-optional" className="text-sm text-gray-400">
            optional
          </span>
        )}
      </div>

      <Select
        required={props.required}
        placeholder={
          <div className="flex items-center">
            <SearchIcon className="w-4 mr-1" /> {t("common.selector.search")}
          </div>
        }
        value={
          !!props.defaultValue && {
            value: props.defaultValue,
            label: props.defaultValue,
          }
        }
        onChange={(value) => {
          // @ts-ignore
          props.onBlur!({ target: { value: value?.value } });
        }}
        className="mt-1 focus:ring-cyan-500 focus:border-cyan-500 border-gray-300 sm:text-sm"
        styles={styles}
        classNames={{
          control: ({ isFocused }) =>
            `border border-gray-300 rounded-md ${
              isFocused ? "border-cyan-500" : ""
            }`,
          option: ({ isFocused, isSelected }) =>
            classNames(
              isFocused ? "bg-cyan-500" : "",
              isSelected ? "bg-cyan-400" : ""
            ),
        }}
        options={options?.toSorted((a, b) => a.label.localeCompare(b.label))}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
};

export default SearchSelectInput;
